import { ACTUALIZAR_LIST_OPD, AGREGAR_OPD, MODIFICAR_OPD, ELIMINAR_OPD } from "./opdActions";

const opdReducer = (state, action) => {
    switch (action.type) {

        case ACTUALIZAR_LIST_OPD: {
            return {
                ...state,
                opdList: action.payload
            }
        };

        case AGREGAR_OPD: {
            return {
                ...state,
                opdList: [action.payload, ...state.opdList]
            }
        };

        case MODIFICAR_OPD: {
            return {
                ...state,
                opdList: state.opdList.map(opd =>
                    opd._id === action.payload._id ? action.payload : opd
                )
            }
        };

        case ELIMINAR_OPD: {
            return {
                ...state,
                opdList: state.opdList.filter(opd => opd._id !== action.payload)
            }
        };

        default:
            return state;
    }
}

export default opdReducer;
